import { addThreadSubmitHydration, getThreadSubmitDisabledTooltip, } from '#pplx/frontend/apps/ask/ask-input/thread-submission/threadSubmitDisabled.js';
import { ThreadSubmitDisabledContext } from '#pplx/frontend/apps/ask/ask-input/thread-submission/ThreadSubmitDisabledContext.js';
import { useContext } from 'react';
import { useIntl } from 'react-intl';
export function useThreadSubmitDisabled({ hydrationCause, }) {
    const context = useContext(ThreadSubmitDisabledContext);
    const intl = useIntl();
    const disabledReasons = context === undefined ? undefined : addThreadSubmitHydration(context.reasons, hydrationCause);
    return disabledReasons === undefined
        ? undefined
        : getThreadSubmitDisabledTooltip(disabledReasons, intl);
}
//# sourceMappingURL=useThreadSubmitDisabled.js.map